module.exports = __webpack_public_path__ + "static/media/whereareyoubased_mobile.cb117882.png";